import React, { useEffect, useRef, useState, useContext } from "react";
import {
  LowerWrapper,
  ContainerIteration,
  RadioSurvey,
  GeneralStyle,
  UpperWrapper,
  VSection,
  EditSection,
  QuestionWrapper,
  SelectsSection,
  ContainerButtons,
  ContainerTitle,
  EditButton,
  DeleteButton,
  CloneButton,
  SaveToBank,
  TooltipCheckSection,
  TooltipDescriptionContainer,
} from "./QuestionLikeBox.styled";
import { theme as themeConfig } from "../../themes/themes";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import ThumbUpAltTwoToneIcon from "@material-ui/icons/ThumbUpAltTwoTone";
import ThumbDownAltTwoToneIcon from "@material-ui/icons/ThumbDownAltTwoTone";
import MessageYesNo from "../MessageYesNo/index";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import ModalSaveToBank from "../ModalSaveToBank";
import InfoIcon from "@material-ui/icons/Info";

const RadioButtonComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestionLike,
}) => {
  return (
    <RadioSurvey>
      <input
        type="radio"
        id={`radioButtonLike-${elementKey}`}
        name="radioButtonLike"
        defaultValue={elementValue}
        onChange={() => setAnswerQuestionLike(elementValue)}
      />
      {/* <label id="labelRadioSurvey">{elementValue}</label> */}
      {elementValue === "thumbUp" ? (
        <ThumbUpAltTwoToneIcon />
      ) : (
        <ThumbDownAltTwoToneIcon />
      )}
    </RadioSurvey>
  );
};
const QuestionLikeBox = ({
  title,
  setTitle,
  setAnswerQuestionLike,
  colorPicker,
  selectImage,
  mandatory,
  setMandatory,
  editable,
  loadCategories,
  refTitle,
  setRefTitle,
  refIsMandatory,
  setRefIsMandatory,
  refValidationText,
  setRefValidationText,
  refCategory,
  setRefCategory,
  saveQuestionBank,
  handleEdit,
  handleCancel,
  configQuestionStyle,
  setconfigQuestionStyle,
  handleDeleteQuestion,
  idQuestionSurvey,
  globalProps,
  categories,
  identity,
  tooltipInformationCheck,
  tooltipDescriptionText,
  setShowTooltipDescription,
  handleTextAreaText,
  changeTooltipInformationCheck,
  showTooltipDescription,
}) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);

  const [Preview] = useState([
    <RadioButtonComponent
      key={1}
      elementKey={1}
      elementValue={"thumbUp"}
      setAnswerQuestionLike={setAnswerQuestionLike}
      colorPicker={colorPicker}
      selectImage={selectImage}
    />,
    <RadioButtonComponent
      key={2}
      elementKey={2}
      elementValue={"thumbDown"}
      setAnswerQuestionLike={setAnswerQuestionLike}
      colorPicker={colorPicker}
      selectImage={selectImage}
    />,
  ]);

  const rTitle = useRef();
  const rValidationText = useRef();
  const rCategory = useRef();
  const [colorBackground] = useState("#f9f9f9");
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);

  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };

  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  let handleTitleInput = (e) => {
    setTitle(e.target.value);
    setRefTitle(e.target.value);
  };

  let handleMandatory = (e) => {
    setMandatory(e.target.checked);
    setRefIsMandatory(e.target.checked);
  };

  let handleValidationtext = (e) => {
    setRefValidationText(e.target.value);
  };

  let handleRefCategory = (e) => {
    setRefCategory(e.target.value);
  };

  return (
    <GeneralStyle
      isDependent={globalProps.GisDependent}
      editable={editable}
      colorBackground={
        configQuestionStyle.customStyle
          ? configQuestionStyle.background
          : colorBackground
      }
    >
      {editable ? (
        <EditSection>
          <VSection>
            <FormControlLabel
              control={
                <Checkbox
                  checked={refIsMandatory}
                  onChange={(e) => handleMandatory(e)}
                  name="mandatory-check"
                />
              }
              label="Mandatory Question"
            />
            {mandatory ? (
              <input
                onChange={(e) => handleValidationtext(e)}
                ref={rValidationText}
                type="text"
                placeholder="Enter mandatory message here"
                id="mText"
                defaultValue={refValidationText}
              ></input>
            ) : null}
          </VSection>
          <hr />
          <UpperWrapper>
            <QuestionWrapper>
              <label>Question:</label>
              <textarea
                onChange={(e) => handleTitleInput(e)}
                type="text"
                placeholder="Enter your question here"
                defaultValue={refTitle}
                ref={rTitle}
              ></textarea>
            </QuestionWrapper>
            {identity !== "form" && (
              <>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <SelectsSection>
                      <div>
                        <label>Category</label>
                        <select
                          onChange={(e) => handleRefCategory(e)}
                          defaultValue={refCategory}
                          ref={rCategory}
                        >
                          <option value={0}>- Category -</option>
                          {loadCategories()}
                        </select>
                      </div>
                    </SelectsSection>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "35px",
                      paddingTop: "20px",
                    }}
                  >
                    <TooltipCheckSection>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tooltipInformationCheck}
                            onChange={(e) => {
                              changeTooltipInformationCheck(e.target.checked);
                            }}
                            name="tooltip-info-check"
                          />
                        }
                        label="Add information tooltip to question"
                      />
                    </TooltipCheckSection>
                  </Grid>
                </Grid>
                {tooltipInformationCheck && (
                  <Grid
                    container
                    style={{ display: "flex", alignContent: "flex-end" }}
                  >
                    <Grid item xs={12} sm={3}>
                      <></>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TooltipDescriptionContainer>
                        <textarea
                          style={{ height: "80px", resize: "none" }}
                          onChange={(e) => handleTextAreaText(e.target.value)}
                          type="text"
                          placeholder="Type text here..."
                          id="tooltipDescription"
                          defaultValue={tooltipDescriptionText}
                        ></textarea>
                      </TooltipDescriptionContainer>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </UpperWrapper>
        </EditSection>
      ) : null}
      {refTitle ? (
        <LowerWrapper>
          <ContainerTitle
            style={
              configQuestionStyle.customStyle
                ? configQuestionStyle.question
                : stateQuestionsReducer.globalStyle.questions
            }
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              {title}
              {tooltipInformationCheck && tooltipDescriptionText !== "" && (
                <Tooltip
                  placement="left"
                  open={showTooltipDescription}
                  title={
                    <>
                      <Box
                        style={{
                          margin: "0",
                          listStyleType: "circle",
                          lineHeight: "1.3",
                          fontSize: "13px",
                        }}
                      >
                        <span>{tooltipDescriptionText}</span>
                      </Box>
                    </>
                  }
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      setShowTooltipDescription(!showTooltipDescription);
                    }}
                  >
                    <InfoIcon
                      fontSize="small"
                      style={{
                        cursor: "pointer",
                        color: themeConfig.text.primary,
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </ContainerTitle>
        </LowerWrapper>
      ) : null}
      <ContainerIteration
        style={
          configQuestionStyle.customStyle
            ? configQuestionStyle.answer
            : stateQuestionsReducer.globalStyle.answers
        }
        colorBackground={
          configQuestionStyle.customStyle
            ? configQuestionStyle.background
            : colorBackground
        }
      >
        {Preview.map((i) => i)}
      </ContainerIteration>
      {!editable && idQuestionSurvey && !globalProps.questionBank && (
        <div className="overlay-option">
          <div className="bottom-buttons">
            <CloneButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => saveQuestionBank(true)}
            >
              <CloneIcon />
              Clone
            </CloneButton>
            {identity !== "form" && (
              <SaveToBank
                hidden={globalProps.disableButton}
                className="w-25 mt-2 mb-3"
                onClick={() => handleSaveToBank()}
              >
                Save to bank
              </SaveToBank>
            )}
            <DeleteButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              Delete
            </DeleteButton>
            <EditButton
              hidden={globalProps.disableButton}
              className="w-25 mt-2 mb-3"
              onClick={() => handleEdit()}
            >
              Edit
            </EditButton>
          </div>
        </div>
      )}
      {editable && (
        <ContainerButtons>
          <div className="left-container">
            <StyledButtonGenericQuestion
              onClick={() => {
                setshowStyleEdit(true);
              }}
            >
              <StyleQuestion />
              Style
            </StyledButtonGenericQuestion>
            {editable && idQuestionSurvey ? (
              <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                <CancelQuestion />
                Cancel
              </StyledButtonGenericQuestion>
            ) : null}
            <StyledButtonGenericQuestion
              lastElement={true}
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              <DeleteQuestion />
              Delete
            </StyledButtonGenericQuestion>
          </div>
          <div className="right-container">
            <StyledButton
              onClick={() => {
                saveQuestionBank(false);
              }}
            >
              Save
            </StyledButton>
          </div>
        </ContainerButtons>
      )}
      {showStyleEdit && (
        <StyleQuestionContainer
          hideAnswerStyle
          setshowStyleEdit={setshowStyleEdit}
          stateObject={configQuestionStyle}
          setstateObject={setconfigQuestionStyle}
        ></StyleQuestionContainer>
      )}
      {openMessageYesNoModal && (
        <MessageYesNo
          setOpenMessageYesNoModal={setOpenMessageYesNoModal}
          message="Are you sure you want to delete this question?"
          setResponse={setResponse}
        ></MessageYesNo>
      )}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={refCategory}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </GeneralStyle>
  );
};
export default QuestionLikeBox;
